import LessonFormModal from "./LessonFormModal"

export function NewLessonModal({ closeModal, selectedDate }) {
	return <LessonFormModal mode="new" closeModal={closeModal} selectedDate={selectedDate} />
}

export default NewLessonModal
